import type { FaireProductEntity } from "../../entity_types/product";

export const p_sp2yg9spgv: FaireProductEntity = {
  token: "p_sp2yg9spgv",
  type: "product",
  name: "Theater Kid Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d72d77e46b8e059e057cd6dc49c6de1763ff6f55f1183bebe48d842553a26f3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2dfac8c09fe95bfcadc72347b9069d3ee0730bbd07aa224c6c1c7c0ca49c4559.jpeg",
    "https://cdn.faire.com/fastly/8d377aab9bcfeebd51cace7ec317c8eda2b03422d563be019516cedc751c16ac.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/1969b727482e951a50150374e83786eff4b4abdb400da1cb55987caa31362785.jpeg",
    "https://cdn.faire.com/fastly/1c31bc821a0c420089dd5863b1dd0e3b937b6c2b0fa96db26c4ab5a8a378e90a.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you're one act away from a standing ovation and one critique away from a breakdown—these socks get it.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:57.893Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
